// extracted by mini-css-extract-plugin
module.exports = {"xsVisible":"_cinsa_flame-module--xs-visible--ONrL5","xsHidden":"_cinsa_flame-module--xs-hidden--F1OCq","oCinsa__logoflame":"_cinsa_flame-module--o-cinsa__logoflame--XGEOQ"};